<div class="back-button">
    <a href="javascript:void(0)" (click)="goBack()">
        <img src="../../../../assets/svg/fi-rs-arrow-left.svg" alt="Back" loading="lazy">
    </a>
</div>
<div class="main-wrapper">
    <div class="reset-password-link-container">
        <div class="reset-password-link-center">
            <h2>{{ 'auth.reset-password-link.title' | translate }}</h2>
            <p>{{ 'auth.reset-password-link.description' | translate }}</p>

            <form id="reset-password-link-form" class="reset-password-link-form">
                <button type="submit" class="reset-password-link-btn" (click)="openEmailApp()" aria-label="Open email app">{{ 'auth.reset-password-link.button-text' |
                    translate }}</button>
            </form>

            <p class="reset-password-link-resend">{{ 'auth.reset-password-link.resend-link' | translate }} 
                <a href="javascript:void(0)" (click)="onResendLink()">{{ 'auth.reset-password-link.resend-link-text' | translate }}</a>
            </p>
        </div>
    </div>
</div>